import { Loader, Tooltip } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import {
  showAllOptionsFilter,
  useAsyncSelectData
} from "../../../../../mantine/components/AsyncSelect/useAsyncSelectData";
import { THEME_VARS } from "../../../../../utils/constants";
import { FormFieldSelect, type FormFieldSelectProps } from "./FormFieldSelect";

interface FormFieldAsyncSelectProps extends Omit<
  FormFieldSelectProps,
  "data" | "type"
> {
  dataUrl: string;
  apiWithoutCamelization?: boolean;
  labelField?: string;
  type: "async-select";
}

function FormFieldAsyncSelect({
  dataUrl,
  apiWithoutCamelization = false,
  labelField,
  type,
  ...formFieldSelectProps
}: FormFieldAsyncSelectProps) {
  const {
    data,
    hasMinThreeCharsSearch,
    isError,
    isLoading,
    searchValue,
    setSearchValue
  } = useAsyncSelectData({
    dataUrl,
    hasSelectedValue:
      !!formFieldSelectProps.value || !!formFieldSelectProps.defaultValue,
    labelField,
    withoutCamelization: apiWithoutCamelization
  });

  return (
    <FormFieldSelect
      {...formFieldSelectProps}
      data={data}
      filter={showAllOptionsFilter}
      leftSection={
        isLoading ? (
          <Loader size="xs" />
        ) : isError ? (
          <ErrorSectionContent />
        ) : undefined
      }
      nothingFoundMessage={
        hasMinThreeCharsSearch
          ? "Keine Einträge gefunden"
          : "Bitte geben Sie mindestens 3 Zeichen ein."
      }
      searchValue={searchValue}
      type="select"
      value={formFieldSelectProps.value?.toString()}
      onChange={(newValue) =>
        formFieldSelectProps.onChange?.(
          typeof newValue === "string" && /^\d+$/.test(newValue)
            ? parseInt(newValue)
            : newValue
        )
      }
      onSearchChange={setSearchValue}
    />
  );
}

function ErrorSectionContent() {
  return (
    <Tooltip label="Fehler beim Laden der Daten">
      <IconAlertTriangle color={THEME_VARS.error[6]} size="1.2rem" />
    </Tooltip>
  );
}

export { FormFieldAsyncSelect, FormFieldAsyncSelectProps };
